import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DialogControl } from "spark-core-dx/hooks";
import { useVisualExportContext } from "../../contexts/VisualExportContext";

export const VisualExportDialog = () => {
  const {
    exportVisual,
    closeExportDialog,
    selectedType,
    chooseType,
    handleExportVisual,
  } = useVisualExportContext();

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={!!exportVisual}
      title="Export Visual"
      disableOk={!selectedType}
      onOk={handleExportVisual}
      onCancel={closeExportDialog}
      okText="Export"
    >
      <div className="visual-selection-container">
        <VisualExportOption
          typeDefinition="csv"
          selectedType={selectedType}
          icon="file-csv"
          onClick={chooseType}
        />
        <div className="blank-bar" />
        <VisualExportOption
          typeDefinition="xlsx"
          selectedType={selectedType}
          icon="file-excel"
          onClick={chooseType}
        />
        <div className="blank-bar" />
        <VisualExportOption
          // Disable PNG when the visual is a Table
          className={exportVisual?.Type === "Table" ? "disabled" : ""}
          typeDefinition="png"
          selectedType={selectedType}
          icon="file-image"
          onClick={chooseType}
        />
      </div>
    </DialogControl>
  );
};

const VisualExportOption = ({ className, typeDefinition, selectedType, icon, onClick }) => {
  return (
    <div
      className={`visual-selection-option ${
        selectedType === typeDefinition ? "active" : ""
      } ${className || ""}`}
      onClick={() => onClick(typeDefinition)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick(typeDefinition)}
    >
      <FontAwesomeIcon icon={icon} className="visual-export-icon" />
      <div className="visual-export-text">{typeDefinition.toUpperCase()}</div>
    </div>
  );
};
